import axios from "axios";

import MANAGER_API_ROUTES from "manager/config/apiRoutes";
import { API_URL } from "shared/lib/api/setupApi";

export interface RillIframeRequest {
  resource?: string;
  navigation?: boolean;
  type?: string;
  ttl_seconds?: number;
  theme?: string;
}

export interface RillIframeResponse {
  iframeSrc: string;
  runtimeHost: string;
  instanceId: string;
  accessToken: string;
  ttlSeconds: number;
}

const api = {
  getRillIframe: (params: RillIframeRequest): Promise<RillIframeResponse> =>
    axios
      .post(`${API_URL}${MANAGER_API_ROUTES.getRillIframe}`, params)
      .then(({ data }) => data),
};

export default api; 